import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { camps } from '../../../../models/models.generated';


@Component({
    selector: 'app-enrollment-report-item',
    templateUrl: './enrollment-report-item.component.html',
    styleUrls: ['./enrollment-report-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EnrollmentReportItemComponent implements OnInit {

    @Input() public item: camps.EnrollmentReportInfoItem;

    constructor() { }

    ngOnInit() {

    }
}
